<!-- Modal Carga Documento Firmado -->

<ng-template #modalDocumentoFirmado let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h2>Carga Documento Firmado</h2>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click'); emit(this.constants.ACTUALIZAR_TABLA);">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card">
      <div class="card-content">
        <div class="card-body">

          <form class="form-bordered" [formGroup]="archivoFirmado">

            <div class="row"
                 style="justify-content: flex-end; margin-right:-9px !important; margin-top: -20px !important;">
              <button type="button" class="btn btn-success  align-self-end mr-2" [disabled]="archivoFirmado.invalid"
                      (click)="guardarArchivoFirmado(this.archivoFirmado.value);"><i class="ft-plus mr-1"></i>Agregar
              </button>
            </div>

            <img src='assets/img/gifcargando.gif' style="width: 60px; display: block; margin:auto;" *ngIf="procesando">
            <p
              style="text-align: center; background: #f88626; color:#ffffff; padding: 10px; border-radius: 5px; margin-top: 5px;"
              *ngIf="procesando">Procesando Archivo</p>


            <div class="form-group row">
              <div class="col-md-12 col-12">
                <input type="file" accept="application/pdf" (change)="selectFiles($event)" class="form-control"
                       formControlName="adjunto"/>
              </div>
            </div>

          </form>

        </div>
      </div>

    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-info" (click)="c('Close click'); emit(this.constants.ACTUALIZAR_TABLA);">Cerrar</button>
  </div>
</ng-template>
